var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmlette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#EAF6FF",
    opacity: 1,
    "data-original": "#eaf6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8ECFE",
    d: "M50 256C50 123.05 151.348 13.771 281 1.206A258.857 258.857 0 0 0 256 0C114.615 0 0 114.615 0 256s114.615 256 256 256c8.435 0 16.774-.408 25-1.206C151.348 498.229 50 388.95 50 256z",
    opacity: 1,
    "data-original": "#d8ecfe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBC700",
    d: "M84.927 275.505c1.924 4.648 2.429 9.733 1.789 14.722-4.169 32.521 9.353 65.094 35.358 85.099a28.065 28.065 0 0 1 8.816 11.518c12.529 30.348 40.475 51.917 72.989 56.361 4.906.671 9.625 2.433 13.542 5.463 16.116 12.467 36.231 19.337 56.609 19.337 9.162 0 31.869-8.542 31.869-19.55V63.573c0-11.55-20.28-18.246-35.425-12.576-3.453 1.293-7.005 2.121-10.692 2.121a28.12 28.12 0 0 1-3.691-.244 92.998 92.998 0 0 0-12.194-.807c-28.518 0-55.928 13.498-73.322 36.11a28.065 28.065 0 0 1-11.518 8.816c-30.324 12.519-51.884 40.431-56.351 72.913-.685 4.983-2.501 9.76-5.571 13.744-20.152 26.143-24.832 61.355-12.208 91.855z",
    opacity: 1,
    "data-original": "#fbc700"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE02F",
    d: "M144.505 244.706c6.188 18.267 8.33 38.277 6.194 57.869-1.315 12.055 2.783 24.151 10.69 31.565 12.855 12.047 22.922 28.072 29.111 46.341 3.808 11.242 12.32 19.22 22.212 20.823 16.074 2.603 33.918-.559 44.224 22.397 6.179 13.763 26.239 26.424 39.097 31.452 4.742 1.854 9.864-1.605 9.863-6.698-.011-50.797-.094-304.397-.121-384.882-.002-6.552-8.063-9.729-12.488-4.897-7.681 8.388-19.207 16.293-35.389 16.348-11.611.039-32 7.068-36.207 19.4-5.981 17.532-23.036 27.932-38.028 35.474-9.225 4.64-15.773 15.013-17.088 27.068-2.136 19.587-8.49 38.22-18.379 53.89-6.085 9.638-7.499 22.609-3.691 33.85z",
    opacity: 1,
    "data-original": "#ffe02f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#68CA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.479 376.621a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452zM385.898 376.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452zM337.898 328.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452zM385.898 152.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452zM258.143 152.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452z",
    fill: "#68CA44",
    opacity: 1,
    "data-original": "#68ca44"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C41926",
    d: "M117.866 280.274A7.726 7.726 0 1 1 110.14 288a7.725 7.725 0 0 1 7.726-7.726z",
    opacity: 1,
    "data-original": "#c41926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E41F2D",
    d: "M257.898 312.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452zM134.668 152.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452z",
    opacity: 1,
    "data-original": "#e41f2d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C41926",
    d: "M241.898 120.274a7.726 7.726 0 1 1 0 15.452 7.726 7.726 0 0 1 0-15.452z",
    opacity: 1,
    "data-original": "#c41926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68CA44",
    d: "M257.898 263.211c0 31.364-25.425 56.789-56.789 56.789a7.211 7.211 0 0 1-7.211-7.211c0-31.363 25.425-56.789 56.789-56.789a7.211 7.211 0 0 1 7.211 7.211z",
    opacity: 1,
    "data-original": "#68ca44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FC123",
    d: "M250.961 223.726c-22.527 0-40.789-18.262-40.789-40.789a7.211 7.211 0 0 1 7.211-7.211c22.527 0 40.789 18.262 40.789 40.789a7.211 7.211 0 0 1-7.211 7.211z",
    opacity: 1,
    "data-original": "#4fc123"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.898,
    cy: 256,
    r: 48.174,
    fill: "#E41F2D",
    opacity: 1,
    "data-original": "#e41f2d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C41926",
    d: "M357.725 256c0-23.177 16.367-42.53 38.174-47.133a48.374 48.374 0 0 0-10-1.04c-26.605 0-48.174 21.568-48.174 48.174 0 26.605 21.568 48.174 48.174 48.174 3.429 0 6.774-.359 10-1.04-21.807-4.605-38.174-23.958-38.174-47.135z",
    opacity: 1,
    "data-original": "#c41926"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FC123",
    d: "M347.91 402.972c1.82 0 3.647.639 5.118 1.941l11.982 10.604a7.727 7.727 0 0 1-10.242 11.572l-11.982-10.604a7.727 7.727 0 0 1 5.124-13.513zM391.203 326.507a7.727 7.727 0 0 1 5.783 12.848l-10.604 11.981a7.727 7.727 0 0 1-11.572-10.242l10.604-11.981a7.707 7.707 0 0 1 5.789-2.606zM343.203 162.009a7.727 7.727 0 0 1 5.783 12.848l-10.604 11.981a7.727 7.727 0 0 1-11.572-10.242l10.604-11.981a7.71 7.71 0 0 1 5.789-2.606zM347.91 82.971c1.82 0 3.647.639 5.118 1.941l11.982 10.604a7.727 7.727 0 0 1-10.242 11.572l-11.982-10.604a7.727 7.727 0 0 1 5.124-13.513zM134.354 337.257c2.73 0 5.377 1.45 6.782 4.013l7.691 14.03a7.726 7.726 0 0 1-13.549 7.429l-7.691-14.03a7.726 7.726 0 0 1 6.767-11.442z",
    opacity: 1,
    "data-original": "#4fc123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68CA44",
    d: "M220.935 337.284a7.71 7.71 0 0 1 6.068 2.938l9.917 12.556a7.726 7.726 0 1 1-12.127 9.577l-9.917-12.556a7.726 7.726 0 0 1 6.059-12.515zM200.172 211.042a7.726 7.726 0 0 1 4.793 13.79l-12.556 9.917a7.725 7.725 0 0 1-10.852-1.275 7.726 7.726 0 0 1 1.275-10.852l12.556-9.917a7.691 7.691 0 0 1 4.784-1.663z",
    opacity: 1,
    "data-original": "#68ca44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FC123",
    d: "M112.377 208.319a7.728 7.728 0 0 1 7.421 9.893l-4.482 15.359a7.728 7.728 0 0 1-14.836-4.328l4.482-15.359a7.732 7.732 0 0 1 7.415-5.565z",
    opacity: 1,
    "data-original": "#4fc123"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmlette);
export default __webpack_public_path__ + "static/media/Omlette.7f7adf9cf5a62635436fc856cd76bbed.svg";
export { ForwardRef as ReactComponent };